import React, { useState, useMemo } from 'react';
import { translate } from '@utils/i18n';
import { Dialog } from '@progress/kendo-react-dialogs';
import { dateClient } from '@utils/date-client';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import InputTextArea, { StyleVariant } from '@components/InputTextArea/InputTextArea';
import TextInput from '@components/TextInput/TextInput';
import { Button } from '@components/v2/Button';
import { ResolutionStatus } from '../ResolutionStatus';
const namespace = 'features.deficiencies.resolve_modal';
function ResolveModalForm({ resolutionValues, onSubmit, toggleDialog }) {
    const [formData, setFormData] = useState(resolutionValues);
    const clearForm = () => {
        toggleDialog();
        setFormData({
            deficiencyResolutionStatus: null,
            resolutionNotes: '',
            resolvedTechnicianName: '',
            dateResolved: null
        });
    };
    const handleTechnicianNameChange = (value) => {
        setFormData((prevState) => (Object.assign(Object.assign({}, prevState), { resolvedTechnicianName: value })));
    };
    const handleResolutionStatusChange = (newStatusId) => {
        setFormData((prevState) => (Object.assign(Object.assign({}, prevState), { deficiencyResolutionStatus: newStatusId })));
    };
    const kendoDate = useMemo(() => {
        const dateResolved = formData.dateResolved ? formData.dateResolved : new Date();
        return dateClient()
            .year(dateResolved.getFullYear())
            .month(dateResolved.getMonth())
            .date(dateResolved.getDate())
            .hour(0)
            .minute(0)
            .toDate();
    }, [formData.dateResolved]);
    const handleDateChange = (e) => {
        setFormData((prevState) => (Object.assign(Object.assign({}, prevState), { dateResolved: e.value })));
    };
    const preventDateBackspace = (e) => {
        if (e.key === 'Backspace') {
            e.preventDefault();
        }
    };
    const handleResolutionNotesChange = (value) => {
        setFormData((prevState) => (Object.assign(Object.assign({}, prevState), { resolutionNotes: value })));
    };
    return (React.createElement(Dialog, { title: translate('title', { namespace }), className: "qmb-dialog", onClose: toggleDialog },
        React.createElement("fieldset", { className: "form__set--horizontal--compact" },
            React.createElement(TextInput, { id: "resolvedTechnicianName", value: formData.resolvedTechnicianName, name: "resolvedTechnicianName", onChange: (e) => handleTechnicianNameChange(e.target.value), label: translate('resolved_technician_name', { namespace }) })),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement(ResolutionStatus, { value: formData.deficiencyResolutionStatus, onChange: handleResolutionStatusChange, allowAddNew: true }),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("fieldset", { className: "form__set--horizontal--compact" },
            React.createElement("div", { className: "qmb-input--text--x-half form__field", onKeyDown: preventDateBackspace, role: "presentation" },
                React.createElement(DatePicker, { value: kendoDate, onChange: handleDateChange }),
                React.createElement("label", { className: "qmb-label" }, translate('date_resolved', { namespace })))),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement(InputTextArea, { id: "resolutionNotes", name: "resolutionNotes", value: formData.resolutionNotes, onChange: handleResolutionNotesChange, buttonControlled: false, variant: StyleVariant.Light, label: translate('resolution_notes', { namespace }) }),
        React.createElement("div", { className: "modal__footer mt-3 pull-right", style: { justifyContent: 'space-between' } },
            React.createElement(Button, { onClick: clearForm }, translate('cancel', { namespace: 'generic' })),
            React.createElement(Button, { variant: "primary", onClick: () => {
                    void onSubmit({
                        deficiencyResolutionStatus: formData.deficiencyResolutionStatus,
                        resolutionNotes: formData.resolutionNotes,
                        resolvedTechnicianName: formData.resolvedTechnicianName,
                        dateResolved: formData.dateResolved
                    });
                    clearForm();
                } }, translate('update', { namespace: 'generic' })))));
}
export default ResolveModalForm;
